// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2VqQT","savePackageButton":"ClientWallet_savePackageButton__6GTYv"};